import { gql } from "@apollo/client";

export const GET_COMPANY_INFO = gql`
  {
    master(order_by: { id: desc }, limit: 1) {
      bank_name
      bank_acc_no
      bank_acc_name
      id
      company_logo
      company_name
      contact_no
      email
      address
    }
  }
`;

export const GET_PACKAGES = gql`
  query getPackages($where: packages_bool_exp) {
    packages(order_by: { weight: asc }, where: $where) {
      id
      name
      chinese_name
      min
      system_offer
      unit_price
      package_country {
        id
        name
        currency
      }
    }
  }
`;
